
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/404",
      function () {
        return require("private-next-pages/[lang]/404.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/404"])
      });
    }
  